export default __webpack_public_path__ + "static/media/fi2016.8e28fbb0.pdf";